import React, { useEffect } from "react";
import {
  Box,
  TextField,
  IconButton,
  Checkbox,
  Typography,
  Stack,
  Button,
  FormControlLabel,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { QuestionViewCard } from "./QuestionViewCard";

const MultipleChoiceOptionEditor = ({
  options,
  onChange,
  readOnly = false,
  trueOrFalse = false,
  disableOptionChange = false,
  hideTitle = false,
}) => {
  const updateOption = (index, updated) => {
    const newOptions = [...options];
    newOptions[index] = { ...newOptions[index], ...updated };
    onChange(newOptions);
  };

  const addOption = () => {
    onChange([
      ...options,
      { id: crypto.randomUUID(), text: "", isCorrect: false },
    ]);
  };

  const removeOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    onChange(newOptions);
  };

  useEffect(() => {
    if (options.length === 0 && trueOrFalse) {
      onChange([
        { id: crypto.randomUUID(), text: "True", isCorrect: false },
        { id: crypto.randomUUID(), text: "False", isCorrect: false },
      ]);
    }
  }, [options]);

  return (
    <Box component={Paper} p={2} mt={2}>
      {!hideTitle && (
        <Stack
          direction={"row"}
          spacing={1}
          alignItems={"center"}
          sx={{ mb: 1 }}
        >
          <Typography variant="subtitle1" fontWeight={600} mb={1}>
            {trueOrFalse ? "Options" : "Multiple Choice Options"}
          </Typography>
        </Stack>
      )}
      <Stack spacing={2}>
        {options.map((opt, index) => (
          <Stack key={opt.id} direction="row" spacing={2} alignItems="center">
            <TextField
              label={disableOptionChange ? "" : `Option ${index + 1}`}
              value={opt.text}
              onChange={(e) => updateOption(index, { text: e.target.value })}
              fullWidth
              disabled={readOnly || disableOptionChange}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={opt.isCorrect}
                  onChange={(e) =>
                    updateOption(index, { isCorrect: e.target.checked })
                  }
                  disabled={readOnly}
                />
              }
              label="Correct"
            />

            {!readOnly && !disableOptionChange && (
              <IconButton onClick={() => removeOption(index)}>
                <DeleteIcon />
              </IconButton>
            )}
          </Stack>
        ))}

        {!readOnly && (
          <Button
            variant="outlined"
            onClick={addOption}
            startIcon={<AddIcon />}
            sx={{ width: "fit-content" }}
          >
            Add Option
          </Button>
        )}
      </Stack>
    </Box>
  );
};

const MultipleChoiceMarkSchemeStep = ({
  question,
  markScheme,
  onChangeMarkScheme,
  readOnly = false,
  trueOrFalse = false,
  hideTitle = false,
  hideQuestion = false,
}) => {
  return (
    <>
      {!hideQuestion && (
        <QuestionViewCard
          question={question}
          sx={{ mt: 2 }}
          hideMarkScheme
          hideOptions
          collapsibleMenu
        />
      )}
      <MultipleChoiceOptionEditor
        options={markScheme.options || []}
        readOnly={readOnly}
        disableOptionChange={trueOrFalse}
        onChange={(newOptions) =>
          onChangeMarkScheme({ ...markScheme, options: newOptions })
        }
        trueOrFalse={trueOrFalse}
        hideTitle={hideTitle}
      />
    </>
  );
};

export { MultipleChoiceMarkSchemeStep };
